import { render, staticRenderFns } from "./ProtocolActItemCard.vue?vue&type=template&id=b1c66b28"
import script from "./ProtocolActItemCard.vue?vue&type=script&lang=js"
export * from "./ProtocolActItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports